import { GetterTree } from "vuex";
import { PartnerUserRolesState } from "@/store/user_management/partner_user_roles/types";
import { RootState } from "@/store/types";

export const getters: GetterTree<PartnerUserRolesState, RootState> = {
  partnerUserRoles: (state) => state.partnerUserRoles ?? [],
  pageBlocks: (state) => state.pageBlocks ?? [],
};
